import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { withRouter } from "../../_shared/withRouter";
import { globalLoader, globalAlert } from "../../actions/commonActions";
import { checkResetApi, resetPasswordApi } from "../../admin/_actions";
import {
  checkResetSuperAdminApi,
  resetPasswordSuperAdminApi,
} from "../../superadmin/_actions";
import { logOut } from "../../_shared/commonFunction";
import { useTranslation } from "react-i18next";
import InputComponent from "../_common/inputComponent";

const ResetTokenComponent = (props) => {
  const { t } = useTranslation();
  const [linkSent, setLinkSent] = useState(false);
  const [sentMsg, setSentMsg] = useState(null);
  const [apiError, setApiError] = useState(null);
  const [resetToken, setResetToken] = useState(null);
  const [password, setPassword] = useState("");
  const [emptyPassword, setEmptyPassword] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [emptyConfirmPassword, setEmptyConfirmPassword] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [passwordLength, setPasswordLength] = useState(6);

  // New states for password validation dropdown visibility
  const [showPasswordHelper, setShowPasswordHelper] = useState(false);

  // States for validation logic
  const [minSixChar, setMinSixChar] = useState(false);
  const [oneVarIncluded, setOneVarIncluded] = useState(false);
  const [numberIncluded, setNumberIncluded] = useState(false);
  const [specialCharacter, setSpecialCharacter] = useState(false);

  useEffect(() => {
    callBasicApi(); // eslint-disable-next-line
  }, []);

  const callBasicApi = async () => {
    const roleType = props.roleType;
    try {
      let resetToken = window.location.pathname.split("/");
      resetToken = resetToken[resetToken.length - 1];

      if (resetToken) {
        setResetToken(resetToken);
        globalLoader(true);
        let obj = {
          resetToken: resetToken,
        };
        let res;

        if (roleType === "admin") {
          res = await checkResetApi(obj);
        } else {
          res = await checkResetSuperAdminApi(obj);
        }

        if (res?.data?.status !== 200) {
          let errorMsg = res?.data?.message || "Invalid or expired reset token";
          if (errorMsg === "Invalid/Expired Token") {
            errorMsg = "Invalid or expired token";
          }
          setApiError(errorMsg);
        } else {
          if (
            roleType === "admin" &&
            res?.data?.data?.passwordLength > 0 &&
            res?.data?.data?.passwordLength != passwordLength
          ) {
            setPasswordLength(res?.data?.data?.passwordLength);
          }
        }
        globalLoader(false);
      }
    } catch (error) {
      setApiError(error?.response?.data?.message || "An error occurred");
      if (error?.response?.data?.status === 401) {
        logOut(props?.history, `${props?.roleType}/login`);
      }
      globalLoader(false);
    }
  };

  // Password validation handler on input change
  const handlePasswordChange = (val) => {
    let containsNumber = /\d+/; // eslint-disable-next-line
    let specailChar = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    let variableChar = /[A-z]/;

    let isVar = variableChar.test(val);
    let isNum = containsNumber.test(val);
    let isSpc = specailChar.test(val);
    let isLen = val.length >= passwordLength;

    // Update states
    setOneVarIncluded(isVar);
    setNumberIncluded(isNum);
    setSpecialCharacter(isSpc);
    setMinSixChar(isLen);
    setPassword(val);

    // LOGIC ADDED HERE: 
    // Agar sabhi conditions true (green) ho jaye, toh helper ko hide kar do.
    // Agar ek bhi false hai (jaise user ne backspace dabaya), toh wapas show kar do.
    if (isVar && isNum && isSpc && isLen) {
      setShowPasswordHelper(false);
    } else {
      setShowPasswordHelper(true);
    }
  };

  const validateForm = () => {
    let value = true;
    if (!password) {
      setEmptyPassword(true);
      value = false;
    }
    if (!confirmPassword) {
      setEmptyConfirmPassword(true);
      value = false;
    }

    if ((password || confirmPassword) && password !== confirmPassword) {
      value = false;
    }

    if (!minSixChar || !oneVarIncluded || !numberIncluded || !specialCharacter) {
      value = false;
    }

    return value;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let value = await validateForm();
    if (value) {
      const roleType = props.roleType;
      globalLoader(true);
      setApiError(null);
      try {
        let res;
        let obj = {
          resetToken: resetToken,
          password: password,
        };
        if (roleType === "admin") {
          res = await resetPasswordApi(obj);
        } else {
          res = await resetPasswordSuperAdminApi(obj);
        }

        if (res?.data?.status === 200) {
          setLinkSent(true);
          setSentMsg(res?.data?.message);
        } else {
          let errorMsg = res?.data?.message || "An error occurred";
          if (errorMsg === "Invalid/Expired Token") {
            errorMsg = "Invalid or expired token";
          }
          setApiError(errorMsg);
        }
      } catch (error) {
        let errorMsg = error?.response?.data?.message || error?.message || "Request failed with status code 500";
        if (errorMsg === "Invalid/Expired Token") {
          errorMsg = "Invalid or expired token";
        }
        setApiError(errorMsg);
      }
      globalLoader(false);
    }
  };

  return (
    <>
      <div className="auth-screen-wrapper">
        <div className="fix-width-wrapper px-3 mx-auto">
          <div className="auth-body-wrapper">
            <div className="logo-wrapper text-center">
              <img
                src="/assets/icons/eC-Card-Logo.svg"
                alt="EC Card Logo"
                className="logo"
              />
            </div>

            {linkSent ? (
              <div className="forgot-msg-wrapper">
                <div className="forgot-msg-txt py-4 text-center">{sentMsg}</div>
                <Link to={`/${props.roleType}/login`}>
                  <Button
                    type="button"
                    className="btn btn-block"
                    style={{ width: '100%', background: 'transparent', border: 'none', color: '#ffffff', boxShadow: 'none', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                  >
                    <i className="fas fa-arrow-left" style={{ marginRight: '5px' }}></i> {t("auth.resetToken.backToLogin")}
                  </Button>
                </Link>
              </div>
            ) : (
              <form onSubmit={(e) => handleSubmit(e)} className="form-own">
                <>
                  <div className="pt-1">
                    <p className="login-text text-center fw-bold">
                      {t("auth.resetToken.enterPassword")}
                    </p>

                    {/* NEW PASSWORD FIELD WRAPPER WITH FOCUS HANDLERS */}
                    <div
                      className="form-group reg-date login-page position-relative reset-token-password-field"
                      onFocusCapture={() => {
                        // Jab user click karega toh check karenge agar password already 
                        // perfect (sabhi green) hai, toh list show mat karo.
                        if (!(minSixChar && oneVarIncluded && numberIncluded && specialCharacter)) {
                          setShowPasswordHelper(true);
                        }
                      }}
                      onBlurCapture={(e) => {
                        // Dropdown ko hide karein jab user bahar click kare
                        if (!e.currentTarget.contains(e.relatedTarget)) {
                          setShowPasswordHelper(false);
                        }
                      }}
                      style={{ zIndex: showPasswordHelper ? 10 : 1 }}
                    >
                      <InputComponent
                        placeholder={t("auth.resetToken.passwordPlaceholder")}
                        label={t("auth.resetToken.passwordPlaceholder")}
                        name="password"
                        type={passwordVisible ? "text" : "password"}
                        theme="primary"
                        color="#d7eff5"
                        value={password}
                        maxLength="30"
                        autoComplete="new-password"
                        handleCallback={(val) => handlePasswordChange(val)}
                      />
                      <div
                        className="login-password cursor"
                        onClick={() =>
                          setPasswordVisible((current) => !current)
                        }
                        style={{ cursor: 'pointer' }}
                      >
                        {passwordVisible ? (
                          <i className="far fa-eye"></i>
                        ) : (
                          <i className="far fa-eye-slash"></i>
                        )}
                      </div>

                      {/* DROPDOWN HELPER UI */}
                      {showPasswordHelper && (
                        <div className="password-dropdown-helper text-left">
                          <ul className="list-unstyled helper-list m-0">
                            <li className={`${minSixChar ? "active" : ""}`}>
                              {t("common.changePassword.minChars", { count: passwordLength })}
                            </li>
                            <li className={`${oneVarIncluded ? "active" : ""}`}>
                              {t("common.changePassword.atLeastOneVariable")}
                            </li>
                            <li className={`${numberIncluded ? "active" : ""}`}>
                              {t("common.changePassword.atLeastOneNumber")}
                            </li>
                            <li className={`${specialCharacter ? "active" : ""}`}>
                              {t("common.changePassword.atLeastOneSpecial")}
                            </li>
                          </ul>
                        </div>
                      )}

                      <div className="error-text font-12 pl-2">
                        {!password && emptyPassword && (
                          <span>{t("auth.resetToken.passwordRequired")}</span>
                        )}
                      </div>
                    </div>

                    {/* CONFIRM PASSWORD FIELD */}
                    <div className="form-group reg-date login-page position-relative reset-token-password-field mt-3">
                      <InputComponent
                        placeholder={t("auth.resetToken.confirmPasswordPlaceholder")}
                        label={t("auth.resetToken.confirmPasswordPlaceholder")}
                        name="confirmPassword"
                        type={confirmPasswordVisible ? "text" : "password"}
                        theme="primary"
                        color="#d7eff5"
                        value={confirmPassword}
                        maxLength="30"
                        autoComplete="new-password"
                        handleCallback={(val) => {
                          setConfirmPassword(val);
                          // Optional: type karte hi error hide karne ke liye
                          if (val) setEmptyConfirmPassword(false);
                        }}
                      />
                      <div
                        className="login-password cursor"
                        onClick={() =>
                          setConfirmPasswordVisible((current) => !current)
                        }
                        style={{ cursor: 'pointer' }}
                      >
                        {confirmPasswordVisible ? (
                          <i className="far fa-eye"></i>
                        ) : (
                          <i className="far fa-eye-slash"></i>
                        )}
                      </div>

                      {/* FIXED ERROR TEXT LOGIC HERE */}
                      <div className="error-text font-12 pl-2">
                        {!confirmPassword && emptyConfirmPassword ? (
                          <span>
                            {t("auth.resetToken.confirmPasswordRequired")}
                          </span>
                        ) : confirmPassword && confirmPassword !== password ? (
                          <span>
                            {t("auth.resetToken.passwordNotMatched")}
                          </span>
                        ) : null}
                      </div>
                    </div>
                    
                    {apiError && (
                      <div 
                        style={{ 
                          marginTop: '20px', 
                          padding: '12px', 
                          borderRadius: '8px',
                          backgroundColor: 'rgba(255, 100, 100, 0.2)',
                          color: '#ffcccc',
                          textAlign: 'center',
                          fontSize: '14px',
                          border: 'none'
                        }}
                      >
                        {apiError}
                      </div>
                    )}

                    <div className="form-group pt-4 reset-token-actions">
                      <Button
                        type="submit"
                        className="btn btn-secondary-own btn-block btn-own w-100"
                      >
                        <span className=" text-color-primary">
                          {t("auth.resetToken.changePassword")}
                        </span>
                      </Button>
                    </div>

                    <div className="reset-token-back-login pb-3 text-center mt-3">
                      <Link to={`/${props.roleType}/login`} style={{ textDecoration: 'none' }}>
                        <span className="text-white">
                          <i className="fas fa-arrow-left" style={{ marginRight: '5px' }}></i> {t("auth.resetToken.backToLogin")}
                        </span>
                      </Link>
                    </div>
                  </div>
                </>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(ResetTokenComponent);